import React, { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";
import ImageItem from "./ImageItem";
import { Typography } from "@mui/material";

import img from "../../../Images/688888760_C4_WWW_Home_Page_2021_Updates_Lighting_Bckt_v2.jpg";
import img2 from "../../../Images/688888760_C4_WWW_Home_Page_2021_Updates_P-of-M_Bckt.jpg";
import img3 from "../../../Images/688888760_C4_WWW_Home_Page_2021_Updates_4Sight_Bckt.jpg";

const images = [
  {
    image: img,
    title:
      "MEETFUTUR Smart Lighting allows you to turn on/off the entire                house when leaving or arriving, start a playlist instantly in                every room, receive feedback if unlocked doors require your                attention, and enjoy lights that manage themselves so you never                come home to a dark house again.",
    btn: "Learn More About Smart Lighting",
  },
  {
    image: img2,
    title:
      "Chime does much more than your typical video doorbell. By                integrating with your MEETFUTUR smart home, Chime allows you to                view and greet guests, turn on the lights, and unlock the door.                Even accept deliveries when you are away. Chime helps keep your                home safer and more secure than never before.",
    btn: "Learn More About Chime",
  },
  {
    image: img3,
    title:
      "MEETFUTUR Connect allows you to be alerted of things at home                while you’re away, including the kids arriving home safely.                Enjoy remote access to cameras, door locks, lights, and more.                Plus get access to voice control and get the tools to further                personalize your smart home after installation.",
    btn: "Learn More About Connect",
  },
];

function ImageScrollInfo() {
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { amount: 0.1 });
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"],
  });

  const opacity = useTransform(
    scrollYProgress,
    [0, 0.15, 0.21, 0.6, 0.75, 0.8],
    [0, 0, 1, 1, 1, 0]
  );

  const translateY = useTransform(
    scrollYProgress,
    [0, 0.15, 0.21, 0.6, 0.75, 0.8],
    [50, 50, 0, 0, 0, -50]
  );

  const textOpacity = useTransform(
    scrollYProgress,
    [0, 0.25, 0.3, 1],
    [1, 1, 0, 0]
  );

  const textOpacity2 = useTransform(
    scrollYProgress,
    [0, 0.3, 0.4, 0.5, 0.55, 1],
    [0, 0, 1, 1, 0, 0]
  );

  const textOpacity3 = useTransform(
    scrollYProgress,
    [0, 0.55, 0.65, 1],
    [0, 0, 1, 1]
  );

  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(isInView);
  }, [isInView]);

  return (
    <div
      id="boxInfoShow"
      ref={containerRef}
      className="flex flex-col items-end md:gap-10"
      style={{
        minHeight: "150vh",
        position: "relative",
        backgroundColor: "#fff",
      }}
    >
      {show && (
        <motion.div
          className="flex-col items-start justify-center gap-6 fixed top-[calc(50vh_-_310px)] left-0 h-[620px] bg-[#f6f6f7] px-10 z-20 md:w-[430px] lg:w-[500px] xl:w-[550px] 2xl:w-[600px] hidden md:flex"
          style={{
            opacity: opacity,
            y: translateY,
          }}
        >
          <Typography
            variant="subtitle1"
            color="primary.dark"
            sx={{ textTransform: "uppercase", fontWeight: 300, fontSize: 17 }}
          >
            Smart Home | Operating System
          </Typography>
          <Typography
            variant="h4"
            color="primary.content"
            sx={{ textTransform: "uppercase" }}
          >
            <span style={{ fontWeight: 300 }}>Sometimes the Little Things</span>
            <br />
            <b>Are the Big Things</b>
          </Typography>
          <div className="relative w-full">
            <motion.div
              className="relative"
              style={{
                opacity: textOpacity,
                zIndex: textOpacity,
              }}
            >
              <Typography mb={3} lineHeight={1.9} fontWeight={300}>
                MEETFUTUR Smart Lighting allows you to turn on/off the entire
                house when leaving or arriving, start a playlist instantly in
                every room, receive feedback if unlocked doors require your
                attention, and enjoy lights that manage themselves so you never
                come home to a dark house again.
              </Typography>
              {/* <Button
                variant="outlined"
                sx={{
                  py: 2,
                  color: "#000",
                  borderColor: "#000",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                    color: "primary.contrastText",
                    borderColor: "primary.dark",
                  },
                }}
              >
                Learn More About Smart Lighting
              </Button> */}
            </motion.div>

            <motion.div
              className="absolute top-0 left-0"
              style={{
                opacity: textOpacity2,
                zIndex: textOpacity2,
              }}
            >
              <Typography mb={3} lineHeight={1.9} fontWeight={300}>
                Chime does much more than your typical video doorbell. By
                integrating with your MEETFUTUR smart home, Chime allows you to
                view and greet guests, turn on the lights, and unlock the door.
                Even accept deliveries when you are away. Chime helps keep your
                home safer and more secure than never before.
              </Typography>
              {/* <Button
                variant="outlined"
                sx={{
                  py: 2,
                  color: "#000",
                  borderColor: "#000",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                    color: "primary.contrastText",
                    borderColor: "primary.dark",
                  },
                }}
              >
                Learn More About Chime
              </Button> */}
            </motion.div>

            <motion.div
              className="absolute top-0 left-0"
              style={{
                opacity: textOpacity3,
                zIndex: textOpacity3,
              }}
            >
              <Typography mb={3} lineHeight={1.9} fontWeight={300}>
                MEETFUTUR Connect allows you to be alerted of things at home
                while you’re away, including the kids arriving home safely.
                Enjoy remote access to cameras, door locks, lights, and more.
                Plus get access to voice control and get the tools to further
                personalize your smart home after installation.
              </Typography>
              {/* <Button
                variant="outlined"
                sx={{
                  py: 2,
                  color: "#000",
                  borderColor: "#000",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                    color: "primary.contrastText",
                    borderColor: "primary.dark",
                  },
                }}
              >
                Learn More About Connect
              </Button> */}
            </motion.div>
          </div>
        </motion.div>
      )}
      {images.map((iteme) => (
        <ImageItem key={iteme.title} item={iteme} />
      ))}
    </div>
  );
}

export default ImageScrollInfo;
